import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { StoreService } from './store.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private storeService: StoreService, public router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (!this.storeService.kioskSettings.kioskEnabled) {
      let registerId = route.params['registerId'];
      let kioskId = route.params['kioskId'];
      if (registerId) {
       
          this.router.navigate([`/dashboard/${registerId}`]);
      }
      return false;
    }
    return true;
  }

}
